import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#packages", label: "Packages" },
  { href: "#gallery", label: "Gallery" },
  { href: "#about", label: "About" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="w-9 h-9 bg-red-500 flex items-center justify-center font-display text-black text-lg">
            R
          </span>
          <span className="font-display text-xl tracking-tight">
            ROYSTON<span className="text-red-500">.</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-widest uppercase text-zinc-400 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="tel:+19206278405"
          data-testid="nav-cta-call"
          className="hidden lg:inline-flex items-center gap-2 bg-red-500 hover:bg-red-400 text-white px-6 py-3 font-bold text-xs tracking-widest uppercase transition-all duration-300"
        >
          <Phone size={14} /> Call 920 627 8405
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="text-base tracking-widest uppercase text-zinc-300 hover:text-red-500 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:+19206278405"
              className="bg-red-500 text-white px-6 py-4 font-bold text-xs tracking-widest uppercase text-center"
            >
              Call 920 627 8405
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
